import "./styles/Contact.css";
import { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

function Contact() {
  const [fullNameContact, setFullNameContact] = useState("");
  const [phoneNumberContact, setPhoneNumberContact] = useState("");
  const [emailContact, setEmailContact] = useState("");
  const [messageContact, setMessageContact] = useState("");
  const [showMessageConfirmation, setShowMessageConfirmation] = useState(false);

  const handleMessage = async () => {
    if (
      !fullNameContact.trim() ||
      !phoneNumberContact.trim() ||
      !emailContact.trim() ||
      !messageContact.trim()
    ) {
      alert("Molimo Vas da popunite sva polja kako biste poslali poruku!");
      return;
    }

    setShowMessageConfirmation(true);

    setTimeout(() => {
      setShowMessageConfirmation(false);
    }, 8000);

    try {
      const response = await axios.post(
        "https://stari-vlah-backend-d6b6be1f828d.herokuapp.com/send-message",
        {
          fullNameContact,
          phoneNumberContact,
          emailContact,
          messageContact,
        }
      );

      console.log(response.data);
    } catch (error) {
      console.error("Greška pri slanju emaila:", error);
      alert("Došlo je do greške pri slanju emaila.");
    }
  };

  return (
    <>
      <Header />
      <div className="mainContactDiv">
        <Helmet>
        <link
            rel="preload"
            href="/images/contactMainImg.jpg"
            as="image"
            
            fetchPriority="high"
          />
          <title>
            Kontakt - Apartman Stari Vlah Zlatibor | Smestaj Zlatibor
          </title>
          <meta
            name="description"
            content="Kontaktirajte nas za brzu i sigurnu rezervaciju Apartmana Stari Vlah Zlatibor. Pronađite sve informacije o našem smeštaju i uživajte u savršenom odmoru!"
          />
          <meta
            name="keywords"
            content="kontakt apartman Zlatibor, rezervacija apartmana Zlatibor, smeštaj Zlatibor kontakt, apartmani Zlatibor broj telefona, najbolji apartmani Zlatibor, apartman Stari Vlah rezervacija, gde odsjesti na Zlatiboru, privatni smeštaj Zlatibor kontakt"
          />
          <script type="application/ld+json">
            {`
      {
        "@context": "http://schema.org",
        "@type": "ContactPage",
        "name": "Apartman Stari Vlah Zlatibor",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+381616836736",
          "contactType": "Customer Service"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Nikole Altomanovića 6",
          "addressLocality": "Zlatibor",
          "postalCode": "31315",
          "addressCountry": "Serbia"
        }
      }
    `}
          </script>
        </Helmet>
        <div className="contactHeadDiv">
          <img src="/images/contactMainImage.webp" className="contactMainImg" />
          <h1 className="contactHeaderName">Apartman Stari Vlah</h1>
          <motion.h2 className="contactHeader" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>Kontakt</motion.h2>

          <motion.h3 className="contactFormParagraph" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>
            Dragi posetioci, ukoliko imate bilo kakvih pitanja u vezi
            dostupnosti, opremljenosti, lokacije, cene smeštaja ili vam je bilo
            šta potrebno, osoblje Apartmana Stari Vlah je tu da vas uputi.
          </motion.h3>
          <div className="hugeContactDiv">
            <div className="bigContactDiv">
              <h2 className="contactUsHeader">Kontaktirajte nas</h2>
              <p className="contactUsParagraph">
                Kontaktirajte nas i odgovorićemo Vam u što kraćem periodu.
              </p>
              <div className="contactFormInputDiv" style={{ marginTop: "7vh" }}>
                <label className="contactFormLabel">Ime i prezime</label>
                <input
                  name="firstLastName"
                  type="text"
                  className="contactFormInput"
                  required
                  value={fullNameContact}
                  onChange={(e) => setFullNameContact(e.target.value)}
                  aria-label="Full Name"
                ></input>
              </div>
              <div className="contactFormInputDiv">
                <label className="contactFormLabel">Telefon</label>
                <input
                  name="phoneNumber"
                  type="number"
                  className="contactFormInput"
                  required
                  value={phoneNumberContact}
                  onChange={(e) => setPhoneNumberContact(e.target.value)}
                  aria-label="Phone Number"
                ></input>
              </div>
              <div className="contactFormInputDiv">
                <label className="contactFormLabel">Imejl</label>
                <input
                  name="email"
                  type="email"
                  className="contactFormInput"
                  required
                  value={emailContact}
                  onChange={(e) => setEmailContact(e.target.value)}
                  aria-label="Email address"
                  aria-invalid={emailContact ? "false" : "true"}
                  aria-describedby="emailErrorMessage"
                ></input>
              </div>
              <div className="contactFormInputDiv">
                <label className="contactFormLabel">Poruka</label>
                <textarea
                  className="contactTextArea"
                  name="message"
                  required
                  value={messageContact}
                  onChange={(e) => setMessageContact(e.target.value)}
                  aria-label="Message Input"
                ></textarea>
              </div>
              <div className="contactFormInputDiv" style={{ marginTop: "6vh" }}>
                <button
                  type="submit"
                  className="submitMessageBtn"
                  onClick={handleMessage}
                  aria-label="Submit Message"
                >
                  Pošalji poruku
                </button>
              </div>
            </div>

              <div className="contactInfoDiv">
                <h3 className="contactInfoHeader">Kontakt informacije</h3>
                <p className="contactParagraph2">
                  Stojimo Vam na raspolaganju za sva pitanja i informacije.
                </p>
                <div
                  className="contactInfoAddress"
                  style={{ marginTop: "5vh" }}
                >
                  <img
                    src="/images/contactUsLocation.webp"
                    className="contactUsIcon"
                  />
                  <p className="contactUsParagraphText">
                    Nikole Altomanovića 6, Zlatibor
                  </p>
                </div>
                <div className="contactInfoAddress">
                  <img
                    src="/images/contactUsPhone.webp"
                    className="contactUsIcon"
                  />
                  <p className="contactUsParagraphText">+ (381) 61 68 36 736</p>
                </div>
                <div className="contactInfoAddress">
                  <img
                    src="/images/contactUsPhone.webp"
                    className="contactUsIcon"
                  />
                  <p className="contactUsParagraphText">+ (381) 61 24 23 547</p>
                </div>
                <div className="contactInfoAddress">
                  <img
                    src="/images/contactUsMail.webp"
                    className="contactUsIcon"
                  />
                  <p className="contactUsParagraphText">dulebondok@gmail.com</p>
                </div>
              </div>
           
          </div>
        </div>

        {showMessageConfirmation && (
          <motion.div
            className="confirmationMessageDiv"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <p className="confirmationText">
              ✅ Vaša poruka je uspešno poslata! <br></br>Osoblje apartmana će
              Vas uskoro kontaktirati.
            </p>
          </motion.div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Contact;
